if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // On /cart the shopper can add from "ربما يعجبك أيضاً". `this.cart` is the notification
      // (or drawer), so only that got re-rendered — the cart lines and totals on the page
      // behind it kept showing the pre-add state until a manual refresh. Ask for the cart
      // page's own sections in the same request and render them too.
      const cartPageSections = this.getCartPageSectionsToRender();
      if (this.cart || cartPageSections.length) {
        const sectionIds = (this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [])
          .concat(cartPageSections.map((section) => section.section));
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
        if (this.cart) this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            // No notification or drawer to render into. On the cart page we can still
            // update in place; anywhere else keep the old navigate-to-cart fallback.
            if (cartPageSections.length) {
              this.error = false;
              this.renderCartPageSections(response);
              return;
            }
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          this.renderCartPageSections(response);
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // The /cart page's own sections. Empty everywhere else, which is what makes the two
    // call sites above no-ops outside /cart.
    getCartPageSectionsToRender() {
      return [
        { id: 'main-cart-items', selector: '.js-contents' },
        { id: 'main-cart-footer', selector: '.js-contents' }
      ]
        .map((entry) => {
          const el = document.getElementById(entry.id);
          return el && el.dataset.id ? Object.assign({}, entry, { section: el.dataset.id }) : null;
        })
        .filter(Boolean);
    }

    renderCartPageSections(response) {
      const sections = this.getCartPageSectionsToRender();
      if (!sections.length || !response || !response.sections) return;

      sections.forEach((entry) => {
        const html = response.sections[entry.section];
        if (!html) return;
        const container = document.getElementById(entry.id);
        if (!container) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const target = container.querySelector(entry.selector);
        const incoming = parsed.querySelector(entry.selector);

        if (target && incoming) {
          target.innerHTML = incoming.innerHTML;
          return;
        }
        // Selector missing on one side — swap the whole section body instead of grafting a
        // fragment into the wrong parent, which would drop the surrounding markup.
        const incomingContainer = parsed.getElementById(entry.id);
        if (incomingContainer) container.innerHTML = incomingContainer.innerHTML;
      });

      // An add always leaves the cart non-empty, so drop the empty-state class the page was
      // rendered with — otherwise the first add to an empty cart shows the new lines
      // underneath "your cart is empty".
      const cartItems = document.querySelector('cart-items');
      if (cartItems) cartItems.classList.remove('is-empty');
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.remove('is-empty');

      document.querySelectorAll('quantity-input').forEach((node) => {
        if (typeof node.syncButtonState === 'function') node.syncButtonState();
      });

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { source: 'product-form' }
      }));
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
